/* eslint-disable */
import ClearIcon from '@mui/icons-material/Clear'
import {
  FormControl,
  MenuItem,
  OutlinedInput,
  Select
} from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Modal from '@mui/material/Modal'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import 'react-phone-number-input/style.css'
import ApiService from '../ApiService'
import { EMULATOR_CREATE_URL } from '../constants'
import '../scss/login.scss'
import { useStates } from '../StateProvider'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: '-3px -3px 7px #97949473, 2px 2px 7px rgb(137, 138, 138)',
  pt: 2,
  px: 4,
  pb: 3
}

const PopUpEmulator = ({ handleClose, handleOpen, updatedEmulator }) => {
  const { showToast } = useStates()
  const [emulatorDetails, setEmulatorDeatils] = useState({
    name: '',
    truck: '',
    trailer: '',
    software: '',
    updateInSec: 5
  })

  const handleSubmitEmulator = async (e) => {
    e.preventDefault()
    const token = localStorage.getItem('token')
    const payload = emulatorDetails
    // POST Emulator
    const { success, error } = await ApiService.makeApiCall(
      EMULATOR_CREATE_URL,
      'POST',
      payload,
      token,
      null
    )
    if (success) {
      showToast('Emulator has been created successfully', 'success')
    } else {
      console.error('Error emulator', error)
      showToast('Emulator not created', 'error')
    }
    updatedEmulator()
    handleClose()
  }

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, // Fixed maxHeight calculation
        width: 250,
        '&::-webkit-scrollbar': {
          width: '8px'
        },
        '&::-webkit-scrollbar-track': {
          background: '#ffff'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#212529',
          borderRadius: '4px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#212529'
        }
      }
    },
    ListProps: {
      sx: {
        fontSize: '12px',
        fontFamily: "'Poppins', sans-serif !important",
        fontWeight: '400'
      }
    }
  }

  return (
    <div>
      {/* Emulator modal */}
      <Modal
        open={handleOpen}
        // userToEdit={userToEdit}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: 400,
            overflow: 'hidden',
            borderRadius: '4px'
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1
            }}
            onClick={handleClose}
          >
            <ClearIcon />
          </IconButton>
          <form onSubmit={handleSubmitEmulator}>
            <h1
              style={{
                marginBottom: '0.5rem',
                fontSize: '1.5rem',
                fontWeight: '600'
              }}
              className="delete-modal-heading"
            >
              {'Add Emulator'}
            </h1>
            <hr style={{ width: '100%', borderTop: '1px solid #E5E5E5' }} />

            {/* Name */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Name </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              // placeholder="Enter your first name"
              className="editAddUserFieldsAlign global-font mt-0"
              style={{ marginBottom: '12px' }}
              onChange={(e) =>
                setEmulatorDeatils({
                  ...emulatorDetails,
                  name: e.target.value
                })
              }
            />

            {/* Truck */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Truck </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="truck"
              name="truck"
              // placeholder="Enter your last name"
              className="editAddUserFieldsAlign global-font mt-0"
              style={{ marginBottom: '12px' }}
              onChange={(e) =>
                setEmulatorDeatils({
                  ...emulatorDetails,
                  truck: Number(e.target.value)
                })
              }
            />

            {/* Trailer */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Trailer </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="trailer"
              name="trailer"
              // placeholder="Enter your email"
              className="editAddUserFieldsAlign global-font mt-0"
              style={{ marginBottom: '12px' }}
              onChange={(e) =>
                setEmulatorDeatils({
                  ...emulatorDetails,
                  trailer: Number(e.target.value)
                })
              }
            />

            {/* Software */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Software </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="software"
              name="software"
              // placeholder="Enter your email"
              className="editAddUserFieldsAlign global-font mt-0"
              style={{ marginBottom: '12px' }}
              onChange={(e) =>
                setEmulatorDeatils({
                  ...emulatorDetails,
                  software: e.target.value
                })
              }
            />
            <FormControl fullWidth style={{ marginBottom: '5px' }}>
              <label className="label-of-create-trip">
                Select Update Interval<span className="text-danger">*</span>
              </label>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={emulatorDetails.updateInSec}
                onChange={(e) =>
                  setEmulatorDeatils({
                    ...emulatorDetails,
                    updateInSec: e.target.value
                  })
                }
                input={
                  <OutlinedInput
                    sx={{
                      height: '36px',
                      fontFamily: "'Poppins', sans-serif !important",
                      fontWeight: '400 !important',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ccc', // Default border color
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#A3A3A3', // Border color on hover
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#A3A3A3', // Border color on focus (click)
                        borderRadius: '4px',
                        borderWidth: '0.3px'
                      },
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: '16px'
                    }}
                  />
                }
                MenuProps={MenuProps}
              >
                <MenuItem value={1}>1 Second</MenuItem>
                <MenuItem value={5}>5 Seconds</MenuItem>
                <MenuItem value={15}>15 Seconds</MenuItem>
                <MenuItem value={30}>30 Seconds</MenuItem>
              </Select>
            </FormControl>

            <Button
              style={{
                backgroundColor: '#00C72E',
                color: '#ffff',
                border: 'none',
                width: '97px',
                height: '38px',
                borderRadius: '4px !important',
                float: 'right',
                marginTop: '5px'
              }}
              className="global-font rounded-2 py-2 fw-medium ms-0 mb-1 me-0"
              type="submit"
            >
              Add
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  )
}

export default PopUpEmulator
